import { hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// hydrateRoot (NOT createRoot): adopt the prerendered HTML in place instead of
// throwing it away and re-rendering the whole page. createRoot was destroying and
// rebuilding every node on mount — that's what made the hero visibly "reload" a
// few seconds after the fast initial paint. With hydrateRoot the hero <img> node
// is preserved (never re-fetched/re-decoded), so the page that paints IS the page.
//
// The prerender is a puppeteer DOM snapshot, so scripts/prerender.mjs adds the
// markers React's own server output carries (<!--$--> around each Suspense
// boundary, <!-- --> between adjacent text nodes) and the page hydrates in
// place. Without them every page reported error 418 at the router's
// <Suspense> and React rebuilt it from scratch: the 2.8 s LCP on phones.
// A mismatch now means something renders differently in the browser than in
// the snapshot (see useIsMobile for the pattern), so it is logged, not hidden.
hydrateRoot(document.getElementById("root")!, <App />, {
  onRecoverableError: (error) => {
    console.warn("Hydration fell back to a client render:", error instanceof Error ? error.message : String(error));
  },
});
